import { gql } from '@apollo/client';
import Fragments from './fragments';
import CommonFragments from 'features/common/fragments';

export const FINANCIAL_PRODUCT_RULE_UPDATED = gql`
  subscription financialProductRuleUpdated {
    financialProductRuleUpdated {
      financialProductRule {
        ...financialProductRuleEditItem
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.financialProductRuleEditItem}
  ${CommonFragments.messageHeaders}
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DATA_UPDATED = gql`
  subscription financialProductRuleOutputDataUpdated {
    financialProductRuleOutputDataUpdated {
      outputData {
        ...financialProductRuleEditOutputDataItem
      }
    }
  }
  ${Fragments.financialProductRuleEditOutputDataItem}
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DATA_REMOVED = gql`
  subscription financialProductRuleOutputDataDeleted {
    financialProductRuleOutputDataDeleted {
      outputDataId
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DICTIONARY_UPDATED = gql`
  subscription financialProductRuleOutputDictionaryUpdated {
    financialProductRuleOutputDictionaryUpdated {
      outputDictionaryId
      orderNo
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DICTIONARY_REMOVED = gql`
  subscription financialProductRuleOutputDictionaryDeleted {
    financialProductRuleOutputDictionaryDeleted {
      outputDictionaryId
    }
  }
`;


export const FINANCIAL_PRODUCT_RULE_COMMISSION_UPDATED = gql`
  subscription financialProductRuleCommissionUpdated {
    financialProductRuleCommissionUpdated {
      commissionId
      orderNo
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_COMMISSION_REMOVED = gql`
  subscription financialProductRuleCommissionDeleted {
    financialProductRuleCommissionDeleted {
      commissionId
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_SERVICE_UPDATED = gql`
  subscription financialProductRuleServiceUpdated {
    financialProductRuleServiceUpdated {
      serviceId
      orderNo
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_SERVICE_REMOVED = gql`
  subscription financialProductRuleServiceDeleted {
    financialProductRuleServiceDeleted {
      serviceId
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_INCOME_UPDATED = gql`
  subscription financialProductRuleIncomeUpdated {
    financialProductRuleIncomeUpdated {
      incomeId
      orderNo
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_INCOME_REMOVED = gql`
  subscription financialProductRuleIncomeDeleted {
    financialProductRuleIncomeDeleted {
      incomeId
    }
  }
`;